import { render, staticRenderFns } from "./EntityMediaAttributes.vue?vue&type=template&id=79f00da4&scoped=true"
import script from "./EntityMediaAttributes.vue?vue&type=script&lang=js"
export * from "./EntityMediaAttributes.vue?vue&type=script&lang=js"
import style0 from "./EntityMediaAttributes.vue?vue&type=style&index=0&id=79f00da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f00da4",
  null
  
)

export default component.exports